// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f4f1ec33","285":"f47ce0f0","415":"c2defd71","497":"eccc3e7e","727":"780929fc"}[chunkId] + ".chunk.js";
};